module.exports = require("@mui/icons-material/KeyboardDoubleArrowRight");